import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import Component from 'flarum/common/Component';

// Sticker packs data
const STICKER_PACKS = [
    {
        name: '最终物语',
        slug: 'fabula-ultima',
        stickers: [
            { file: '1_大成功.png', alt: '大成功', shortcode: ':fu-crit:' },
            { file: '2_大失败.png', alt: '大失败', shortcode: ':fu-fail:' },
            { file: '3_跑团启动.png', alt: '跑团启动', shortcode: ':fu-start:' },
            { file: '4_带我跑团.png', alt: '带我跑团', shortcode: ':fu-lfg:' },
            { file: '5_正在瞎编.png', alt: '正在瞎编', shortcode: ':fu-improv:' },
            { file: '6_撕几张卡.png', alt: '撕几张卡', shortcode: ':fu-rip:' },
            { file: '7_不说话了.png', alt: '不说话了', shortcode: ':fu-silent:' },
            { file: '8_一定不鸽.png', alt: '一定不鸽', shortcode: ':fu-promise:' },
            { file: '9_阳光开朗.png', alt: '阳光开朗', shortcode: ':fu-sunny:' },
            { file: '10_不是刁民.png', alt: '不是刁民', shortcode: ':fu-innocent:' },
            { file: '11_无语.png', alt: '无语', shortcode: ':fu-speechless:' },
            { file: '12_变成萌妹.png', alt: '变成萌妹', shortcode: ':fu-cute:' },
            { file: '13_羁绊.png', alt: '羁绊', shortcode: ':fu-bond:' },
            { file: '14_拿来吧你.png', alt: '拿来吧你', shortcode: ':fu-gimme:' },
            { file: '15_亮血条吧.png', alt: '亮血条吧', shortcode: ':fu-hp:' },
            { file: '16_溜了溜了.png', alt: '溜了溜了', shortcode: ':fu-flee:' },
        ],
    },
];

class StickerPicker extends Component {
    oninit(vnode) {
        super.oninit(vnode);
        this.activePack = 0;
    }

    view() {
        const pack = STICKER_PACKS[this.activePack];
        const baseUrl = app.forum.attribute('baseUrl') + '/assets/stickers/' + pack.slug + '/';

        return m('.StickerPicker', [
            // Pack tabs
            m('.StickerPicker-tabs', STICKER_PACKS.map((p, i) =>
                m('button.StickerPicker-tab', {
                    className: i === this.activePack ? 'active' : '',
                    onclick: () => { this.activePack = i; },
                }, p.name)
            )),
            // Sticker grid
            m('.StickerPicker-grid',
                pack.stickers.map(sticker =>
                    m('button.StickerPicker-item', {
                        title: sticker.alt,
                        onclick: () => this.insertSticker(baseUrl, sticker),
                    }, m('img', {
                        src: baseUrl + encodeURIComponent(sticker.file),
                        alt: sticker.alt,
                        loading: 'lazy',
                    }))
                )
            ),
        ]);
    }

    insertSticker(baseUrl, sticker) {
        const url = baseUrl + encodeURIComponent(sticker.file);
        const markdown = `![${sticker.alt}](${url} "${sticker.alt}")`;

        if (this.attrs.onInsert) {
            this.attrs.onInsert(markdown);
        }
    }
}

app.initializers.add('bo3studio/flarum-stickers', () => {
    extend(TextEditor.prototype, 'toolbarItems', function (items) {
        const editor = this;

        items.add('stickers',
            m('.ButtonGroup', [
                m('button.Button.Button--icon.hasIcon', {
                    className: 'Button--flat',
                    title: '表情贴纸',
                    onclick: (e) => {
                        e.preventDefault();
                        // Toggle sticker picker
                        if (editor.stickerPickerVisible) {
                            editor.stickerPickerVisible = false;
                        } else {
                            editor.stickerPickerVisible = true;
                        }
                    },
                }, m('i.fas.fa-smile-wink')),
            ]),
            -10
        );

        if (editor.stickerPickerVisible) {
            items.add('sticker-picker',
                m(StickerPicker, {
                    onInsert: (markdown) => {
                        editor.attrs.composer.editor.insertAtCursor(markdown + ' ');
                        editor.stickerPickerVisible = false;
                    },
                }),
                -20
            );
        }
    });
});
